// Recovered compiled webpack factory 88551. Edit this function expression; run npm run build.
(e, t, n) => {
  "use strict";
  n.d(t, { default: () => s });
  var r = n(95155),
    i = n(18720),
    a = n(22286);
  n(89846);
  let o = 1 / 0;
  function s(e) {
    let { aboveFollowScrim: t = !1 } = e;
    return (0, r.jsx)(i.l, {
      position: "bottom-center",
      className: "um-ghost-toaster",
      style: { "--width": "min(480px, calc(100vw - 32px))", zIndex: t ? 10002 : 9998 },
      gap: 10,
      visibleToasts: o,
      expand: !0,
      swipeDirections: ["top", "right", "bottom", "left"],
      toastOptions: {
        unstyled: !0,
        classNames: {
          toast:
            "um-ghost-toast font-['Geist',sans-serif] squircle-xl border border-white/[0.08] bg-[#09090b] text-[#fafafa] shadow-[0_12px_32px_-12px_rgba(0,0,0,0.5)] inline-flex items-center gap-2 px-4 py-2.5",
          content: "flex flex-col items-start gap-0.5 text-left",
          title: "text-[13px] font-normal leading-snug text-white/85",
          description: "text-[12px] font-normal leading-snug text-white/55",
          icon: "relative shrink-0 self-start mt-px flex items-center justify-center size-4 text-[#FD631F] [&_svg]:size-4",
          error: "[&_[data-icon]]:text-[#ef4444]",
          success: "[&_[data-icon]]:text-[#FD631F]",
          info: "[&_[data-icon]]:text-white/60",
          warning: "[&_[data-icon]]:text-[#FD631F]",
          loading: "[&_[data-icon]]:text-white/60",
          actionButton: `ml-1 ${a.GHOST_PILL_BUTTON}`,
          cancelButton: `ml-1 ${a.GHOST_PILL_BUTTON_SECONDARY}`,
          closeButton: "hidden",
        },
      },
    });
  }
}
